import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../../../aGlobalDesign/Modal/Modal";

class InvitationsList extends React.Component {

    constructor() {
        super();
        this.state = {
            forcePaginationUpdate: 0,
            selectedUser: null,
            temporaryElement: null,
            agentsFilteredByCallCenter: [],
            organisationUserGroups: [],
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload")
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.InvitationsList);
        this.props.ChangeCurrentMenuName("InvitationsList");
        if (!this.props.administration.secondaryusergroups) {
            this.props.GetSecondaryUserGroupsList((data) => {
                this.setState({ organisationUserGroups: data.results });
            });
        }
        else {
            this.setState({ organisationUserGroups: this.props.administration.secondaryusergroups.results });
        }
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }
        if (!this.props.monitoring.secondaryportalagents) {
            this.props.GetSecondaryPortalAgentsList();
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedUser: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoadUserClick(null);
        }
    }

    getAgentsList(callCenterId) {
        if (!callCenterId) {return;}

        this.props.GetCallCenterById((data) => {
            this.setState({ agentsFilteredByCallCenter: { results: data.results.portalAgents } });
        }, callCenterId);
    }

    //#region functions
    OnSwitchDisableUser(user, onSuccess) {
        const isDisabled = !user.organizationUser.isDisabled;
        const organizationUser = {
            organizationId: this.props.currentuser.currentorganization.id,
            organization: null,
            displayName: user.displayName,
            userId: user.id,
            callCenterId: user.callCenterId,
            portalAgentId: user.portalAgentId,
            codeAgent: user.codeAgent,
            isDisabled: isDisabled,
            isInvitationPending: user.organizationUser.isInvitationPending,
            isOrganizationAdministrator: user.organizationUser.isOrganizationAdministrator
        };
        //Save Change To DB
        this.props.EditOrganizationUser(organizationUser, onSuccess);
    }

    OnLoadUserClick(suser) {
        let user = suser;
        const orgId = this.props.currentuser.currentorganization.id;
        const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
        const cuportalAgentId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).portalAgentId;

        const callCenterId = this.props.currentuser.accessrights.hasPermission(210, "modify") === 20 ? cucallCenterId : null;
        const portalAgentId = this.props.currentuser.accessrights.hasPermission(220, "modify") === 20 ? cuportalAgentId : null;

        if (user === null) {
            user = {
                id: 0,
                email: "",
                displayName: "",
                codeAgent: "",
                portalAgentId: portalAgentId,
                callCenterId: callCenterId,
                invitMessage: "",
                userGroups: [],
                invitationUserGroupMemberships: []
            };
        }
        const temp = this.CreateTemp(user);
        this.setState({
            selectedUser: user,
            temporaryElement: temp
        });

        if (temp.callCenterId) {
            this.getAgentsList(temp.callCenterId);
        }
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            displayName: element.displayName,
            codeAgent: element.codeAgent,
            email: element.email,
            message: element.message,
            callCenterId: element.callCenterId,
            portalAgentId: element.portalAgentId,
            userGroups: element.userGroups,
            invitationUserGroupMemberships: element.invitationUserGroupMemberships
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.displayName = temp.displayName;
        element.codeAgent = temp.codeAgent;
        element.email = temp.email;
        element.message = temp.message;
        element.callCenterId = temp.callCenterId;
        element.portalAgentId = temp.portalAgentId;
        element.userGroups = temp.userGroups;
        element.invitationUserGroupMemberships = temp.invitationUserGroupMemberships;
        return element;
    }

    OnSaveUserClick() {
        if (this.state.temporaryElement.email === null || this.state.temporaryElement.email === "") {
            this.props.OpenDialog({
                description: strings.emailNeeded,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.temporaryElement.email)) {
            this.props.OpenDialog({
                description: strings.emailNeeded,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const changedElement = this.state.selectedUser;
        this.SaveTemp(this.state.temporaryElement, changedElement);

        if (changedElement.id === 0) {
            const newInvitation = {
                id: 0,
                displayName: changedElement.displayName,
                codeAgent: changedElement.codeAgent,
                email: changedElement.email,
                message: changedElement.invitMessage,
                callCenterId: changedElement.callCenterId,
                portalAgentId: changedElement.portalAgentId,
                organizationId: this.props.currentuser.currentorganization.id,
                organization: null,
                invitationUserGroupMemberships: changedElement.invitationUserGroupMemberships
            };
            console.log("newInvitation", newInvitation);
            this.props.CreateInvitation(newInvitation, (data) => {
                toast.success(strings.invitSuccessfullSave);
                this.forcePaginationUpdate();
            });
        }
    }

    OnResendInvitation(invitation) {
        const Invitation = {
            id: invitation.id,
            email: invitation.email,
            displayName: invitation.displayName,
            codeAgent: invitation.codeAgent,
            message: invitation.message,
            callCenterId: invitation.callCenterId,
            portalAgentId: invitation.portalAgentId,
            organizationId: this.props.currentuser.currentorganization.id,
            organization: null,
            invitationUserGroupMemberships: null,
            timestamp: invitation.timestamp
        };

        this.props.EditInvitation(Invitation, () => {
            toast.success(strings.invitSuccessfullSave);
            this.forcePaginationUpdate();
        });
    }
    getMainUserGroupName(list) {
        console.log("getMainUserGroupName", list);


        if (list.length <= 0) {return "Agent";}
        if (list.some(ug => ug.name === "Admin")) {return "Admin";}
        if (list.some(ug => ug.name === "Manager")) {return "Manager";}
        const defaulIndex = list.findIndex(u => u.name !== "Agent");
        if (defaulIndex < 0) {return list[0].name;}
        else {return list[defaulIndex].name;}
    }
    getMainUserGroupId(list) {
        if (list.length <= 0) {return null;}
        if (list.length > 1) {return list.find(ug => ug.name !== "Agent").id;}
        else {return list[0].id;}
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetInvitationsList}
                onSavePagination={this.props.SaveInvitationPagination}
                myElements={this.props.administration.invitations}

                sortOptions={[
                    { sortName: "displayName", sortData: "asc" },
                    { sortName: "role", sortData: "null" },
                    { sortName: "senddate", sortData: "null" }
                ]}

                tableElement={(element) => {
                    return [
                        {
                            colTitle: strings.SortName,
                            fixedWidth: "400px",
                            sortIndex: 0,
                            colContent: element ? element.displayName : null
                        },
                        {
                            colTitle: strings.SortRole,
                            fixedWidth: "400px",
                            sortIndex: 1,
                            colContent: element && element.userGroups && this.state.organisationUserGroups ?
                                this.getMainUserGroupName(element.userGroups) : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: [0, 1],
                            colContent: [
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    nameIcon="eye"
                                    onClick={() => this.OnLoadUserClick(element)}
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    type="primary"
                                    nameIcon="trash"
                                    onClick={() => {
                                        this.props.OpenDialog({
                                            title: strings.deleteConfirm,
                                            description: strings.textDeleteItem,
                                            secondaryLabel: strings.cancel,
                                            primaryLabel: strings.confirmDelete,
                                            onPrimaryAction: () => {
                                                this.props.DeleteInvitation(element.id, () => this.forcePaginationUpdate());
                                            }
                                        });
                                    }}
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedUser !== null}
                onClose={() => this.forcePaginationUpdate()}
                title={this.state.selectedUser && this.state.selectedUser.id === 0 ? strings.inviteUser : strings.invitationDetail}
                textSecondaryButton={this.state.selectedUser && this.state.selectedUser.id === 0 ? null : strings.Close}
                validationIcon="mail"
                validationTitle={this.state.selectedUser && this.state.selectedUser.id === 0 ? strings.sendInvitation : strings.resendInvitation}
                icon={"mail"}
                fields={
                    this.state.selectedUser ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            width: "110px",
                            placeholder: strings.firstnameLastname,
                            value: this.state.temporaryElement.displayName,
                            onChange: (e) => {
                                const su = this.state.temporaryElement;
                                su.displayName = e.target.value;
                                this.setState({ temporaryElement: su });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.email,
                            width: "110px",
                            placeholder: strings.userMail,
                            value: this.state.temporaryElement.email,
                            disabled: this.state.temporaryElement.id !== 0,
                            onChange: (e) => {
                                const su = this.state.temporaryElement;
                                su.email = e.target.value;
                                this.setState({ temporaryElement: su });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.SortRole,
                            width: "110px",
                            preventEmpty: true,
                            openTop: true,
                            adjustHeight: true,
                            disabled: !accessrights || accessrights.hasPermission(100, "modify") <= 10,
                            elementsList: {
                                results: this.state.organisationUserGroups.map((ug) => ({
                                    id: ug.id,
                                    name: ug.name
                                }))
                            },
                            selectedElementId: this.getMainUserGroupId(this.state.temporaryElement.userGroups),
                            onSelectElement: (selectedGroup) => {
                                if (selectedGroup != null) {
                                    const user = { ...this.state.temporaryElement };

                                    user.userGroups = [selectedGroup];
                                    user.invitationUserGroupMemberships = [{
                                        invitationId: user.id,
                                        userGroupId: selectedGroup.id
                                    }];

                                    this.setState({ temporaryElement: user });
                                }
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.CallCenter,
                            width: "110px",
                            openTop: true,
                            disabled: !accessrights || accessrights.hasPermission(210, "modify") <= 10,
                            elementsList: this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.temporaryElement.callCenterId,
                            onSelectElement: (element) => {
                                const temp = this.state.temporaryElement;

                                if (accessrights.hasPermission(210, "modify") === 20) {
                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                    if (element && element.id !== cucallCenterId) {return;}
                                }
                                temp.callCenterId = element ? element.id : null;
                                // Clean portalAgentId for each change callCenterId
                                temp.portalAgentId = null;

                                this.setState({
                                    temporaryElement: temp,
                                    // Clean agentsFilteredByCallCenter for each change callCenterId
                                    agentsFilteredByCallCenter: { results: [] }
                                });

                                // Wait call getAgentsList for let dropdown cleaning his DOM
                                setTimeout(() => {
                                    if (element.id) {this.getAgentsList(element.id);}
                                }, 0);
                            }
                        }
                    ] : null
                }
                onValidate={ this.state.selectedUser && this.state.selectedUser.id === 0 ?
                    () => this.OnSaveUserClick()
                    :
                    () => this.OnResendInvitation(this.state.selectedUser)
                }
            >
            </Modal>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(InvitationsList);
